import utils from '../utils/utils'
import anime from '../libs/anime'
import globalVar from '../utils/globalVar'

class Dropdown {
  constructor() {
    let scrollPos;
    let cache = {};
    let self = this;
    let scrollElement = window.document.scrollingElement || window.document.body || window.document.documentElement;
    let desktop = window.matchMedia("(min-width: 1024px)");
    let init = () => {
      initCache();
      registerEvents();
    }

    let initCache = () => {
      cache.drop = document.querySelectorAll(".dropdown_wrap .drop");
    };

    let registerEvents = () => {
      for (var i = 0; i < cache.drop.length; i++) {
        if(desktop.matches){
          cache.drop[i].addEventListener('mouseenter', toggleDrop);
          cache.drop[i].addEventListener('mouseleave', toggleDrop);
        }
        else {
          cache.drop[i].addEventListener('click', toggleDrop);
        }
      }
    };

    let toggleDrop = function() {
      var parent = this;
      var list = parent.querySelector('ul');

      if(!parent.classList.contains('active')) {
        parent.classList.add('active');
        list.style.opacity = 0;
        list.style.display = "block";
        list.style.height = 'auto';
        var height = list.offsetHeight;
        list.style.height = 0;
        list.style.opacity = 1;
        anime({
          targets: list,
          height: height,
          duration: 400,
          easing: 'easeInOutExpo',
        });
      }
      else {
        parent.classList.remove('active');
        anime({
          targets: list,
          height: 0,
          duration: 400,
          easing: 'easeInOutQuad',
        });
      }
    }

    init();
  };
}
export { Dropdown }
